"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _excluded = ["size"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var bounce = (0, _styledComponents.keyframes)(["0%,80%,100%{transform:scale(0);}40%{transform:scale(1);}"]);
var Dot = _styledComponents.default.div.withConfig({
  displayName: "loader-dots__Dot",
  componentId: "ui__sc-152guo1-0"
})(["animation:", " 1s ease-in-out infinite both;width:", "px;height:", "px;border-radius:", ";display:inline-block;", " transform:scale(0);&:last-child{", ":0;}&:first-child{animation-delay:-0.32s !important;}&:nth-child(2){animation-delay:-0.16s !important;}"], bounce, function (_ref) {
  var size = _ref.size;
  return size;
}, function (_ref2) {
  var size = _ref2.size;
  return size;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.radius.max;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.dir === "rtl" ? "margin-left:8px;" : "margin-right:8px;";
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.dir === "rtl" ? "margin-left" : "margin-right";
});
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "loader-dots__Wrapper",
  componentId: "ui__sc-152guo1-1"
})(["text-align:center;margin-top:-1px;min-width:calc(16px + ", "px);", "{background-color:", ";}"], function (_ref6) {
  var size = _ref6.size;
  return size * 3;
}, Dot, function (_ref7) {
  var colors = _ref7.theme.colors,
    color = _ref7.color;
  return color || colors.white;
});
function LoaderDots(_ref8) {
  var _ref8$size = _ref8.size,
    size = _ref8$size === void 0 ? 7 : _ref8$size,
    props = (0, _objectWithoutProperties2.default)(_ref8, _excluded);
  return /*#__PURE__*/_react.default.createElement(Wrapper, (0, _extends2.default)({}, props, {
    size: size
  }), /*#__PURE__*/_react.default.createElement(Dot, {
    size: size
  }), /*#__PURE__*/_react.default.createElement(Dot, {
    size: size
  }), /*#__PURE__*/_react.default.createElement(Dot, {
    size: size
  }));
}
var _default = LoaderDots;
exports.default = _default;
//# sourceMappingURL=index.js.map